import { ScrollText } from "lucide-react";
import {
  analectById,
  cleanTranslation,
  conceptsOf,
  extractAnnotationTerms,
  stripAnnotationHeader,
} from "../../engine";
import { CONCEPT_MAP } from "../../data/concepts";
import { useGame } from "../../state/GameProvider";

export function EvidencePanel() {
  const { state } = useGame();
  const { duel } = state;
  const analect = analectById.get(duel.analectId);
  if (!analect) return null;

  const concepts = conceptsOf(analect).map((id) => CONCEPT_MAP.get(id)!.label);
  const terms = extractAnnotationTerms(analect.annotations);
  const keywords = terms.length ? [...concepts, ...terms] : concepts;
  const annotation = analect.annotations
    ? stripAnnotationHeader(analect.annotations.replace(/^注[释釋]：/, ""))
    : "";

  return (
      <section className="panel evidence-panel">
        <div className="panel-title">
          <ScrollText size={15} />
          楊伯峻證據鏈
        </div>
        <div className="evi-block">
          <h4>白話譯文</h4>
          <p>{cleanTranslation(analect.translation)}</p>
        </div>
        <div className="evi-block">
          <h4>注釋要點</h4>
          <p className="evi-ann">{annotation || "本則暫無注釋。"}</p>
        </div>
        <div className="keyword-row">
          {keywords.slice(0, 6).map((keyword) => (
            <span key={keyword} className="kw">
              {keyword}
            </span>
          ))}
        </div>
      </section>
  );
}
